var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4093 12.0069C13.4093 15.4571 10.6314 18.2542 7.20454 18.2542C3.77771 18.2542 1 15.458 1 12.0069C1 8.55581 3.77792 5.75977 7.20454 5.75977C10.6312 5.75977 13.4093 8.55665 13.4093 12.0069ZM20.216 12.0069C20.216 15.2549 18.8269 17.8876 17.1136 17.8876C15.4003 17.8876 14.0112 15.254 14.0112 12.0069C14.0112 8.75975 15.4003 6.12616 17.1136 6.12616C18.8269 6.12616 20.216 8.75975 20.216 12.0069ZM23 12.0069C23 14.9169 22.5114 17.2758 21.9088 17.2758C21.3063 17.2758 20.8177 14.9161 20.8177 12.0069C20.8177 9.09769 21.3063 6.73799 21.9091 6.73799C22.5118 6.73799 23 9.09706 23 12.0069Z",
    fill: "#909090"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.cd3dab164834edeb9245088f7a7ae58f.svg";
export { ForwardRef as ReactComponent };